<template>
  <div class="animated fadeIn">
    <div v-if="checkCardHasCampaign(card) || checkCardHasWebsocketCampaign(card)">
      <table class="table table-hover" style="'border: 1px solid #dcdede;'">
        <thead class="thead-third" style="border: solid 1px #04a791;">
          <tr>
            <th class="text-center" style="font-size: 13px;">Nome</th>
            <th class="text-center" style="font-size: 13px;">
              Data de Conversão
            </th>
            <th class="text-center" style="font-size: 13px;">Modelo</th>
          </tr>
        </thead>
        <tbody v-if="this.card.campanhas && this.card.campanhas.length > 0">
          <tr v-for="(obj, index) in this.card.campanhas" :key="index" href="javascript:void(0)">
            <td
              class="text-center"
              @click="showTemplateModal(obj)"
            >
              <a href="javascript:void(0)">{{ obj.nomeCampanha ? obj.nomeCampanha.toUpperCase() : "" }}</a>
            </td>
            <td
              class="text-center"
              href="javascript:void(0)"
              @click="showTemplateModal(obj)"
            >
              <a href="javascript:void(0)">{{ obj.dataConvercao ? formatDate(obj.dataConvercao) : "" }}</a>
            </td>
            <td
              @click="showTemplateModal(obj)"
              class="text-center"
              style="font-size: 14px; cursor: pointer;"
            >
              <i class="fas fa-eye"></i>
            </td>
          </tr>
        </tbody>
        <tbody v-if="checkCardHasWebsocketCampaign(card)">
          <tr href="javascript:void(0)">
            <td
              class="text-center"
              @click="showUtmModal(card)"
            >
              <a href="javascript:void(0)">{{ card.utmCampaign ? card.utmCampaign.toUpperCase() : "-" }}</a>
            </td>
            <td
              class="text-center"
              href="javascript:void(0)"
              @click="showUtmModal(card)"
            >
              <a href="javascript:void(0)">{{ card.dataCriacao ? formatDate(card.dataCriacao) : "-" }}</a>
            </td>
            <td
              @click="showUtmModal(card)"
              class="text-center"
              style="font-size: 14px; cursor: pointer;"
            >
              <i class="fas fa-eye"></i>
            </td>
          </tr>
        </tbody>
      </table>
      <!--<Tables
        ref="tableGrid"
        :columns="[
          'Nome',
          'Data de Conversão'
        ]"
        :showHeader="false"
        :showPaging="false"
      >
        <tr v-for="obj in this.card.campanhas" v-bind:key="obj.id">
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value="obj.nomeCampanha ? obj.nomeCampanha.toUpperCase() : ''"
          />
          <TableColumn
            :IsDatetime="true"
            v-on:Edit="onEdit(obj)"
            :status="1"
            :value=""
          />
        </tr>
      </Tables> -->
    </div>
    <PreviewTemplateModal
      ref="PreviewTemplateModal"
      :card="card"
    />
    <UtmTemplateModal
      ref="UtmTemplateModal"
      :card="card"
    />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import _ from 'lodash'
import PreviewTemplateModal from './modal/PreviewTemplateModal.vue'
import UtmTemplateModal from './modal/UtmTemplateModal.vue'

export default {
  name: 'CrmDetailsCampanha',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    boardArchived: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hasProducts: false
    }
  },
  components: {
    PreviewTemplateModal, UtmTemplateModal
  },
  methods: {
    onLoad () {
    },
    showTemplateModal (obj) {
      if (!_.isNil(obj.templateModelo)) this.$refs.PreviewTemplateModal.showModal(obj.templateModelo)
    },
    showUtmModal (obj) {
      if (!_.isNil(obj)) this.$refs.UtmTemplateModal.showModal(obj)
    },
    checkCardHasCampaign (card) {
      if (!_.isNil(card) && card.campanhas.length > 0) {
        return true
      }
      return false
    },
    checkCardHasWebsocketCampaign (card) {
      if (card.utmCampaign ||
        card.utmContent ||
        card.utmMedium ||
        card.utmSource ||
        card.utmTerm
      ) {
        return true
      } else {
        return false
      }
    },
    formatDate (d) {
      const date = new Date(d)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      const seconds = date.getSeconds().toString().padStart(2, '0')

      return `${day}/${month}/${year}` + ` às ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/campanha/CampanhaTable.vue